export const indianNumberFormat = new Intl.NumberFormat("en-IN");

export const formatToIndianCurrency = (value: number): string => {
    if (value >= 10000000) {
        return `${indianNumberFormat.format(Number((value / 10000000).toFixed(2)))} Cr`;
    } else if (value >= 100000) {
        return `${indianNumberFormat.format(Number((value / 100000).toFixed(2)))} L`;
    } else if (value >= 1000) {
        return `${indianNumberFormat.format(Number((value / 1000).toFixed(2)))} K`;
    } else {
        return indianNumberFormat.format(value);
    }
};

export const formatPercent = (value: number): string => `${value.toFixed(2)} %`;

export const formatToWeightUnits = (value: number): string => {
    if (value >= 1000) {
        return `${indianNumberFormat.format(Number((value / 1000).toFixed(2)))} Ton`;
    } else if (value >= 100) {
        return `${indianNumberFormat.format(Number((value / 100).toFixed(2)))} Quintal`;
    } else {
        return `${indianNumberFormat.format(value)} kg`;
    }
};
